class LeoCountdown extends HTMLElement {
  constructor() {
    super();
    this.countdownInterval = null;
    this.displayDay = this.querySelector('.days');
    this.displayHour = this.querySelector('.hours');
    this.displayMinute = this.querySelector('.minutes');
    this.displaySecond = this.querySelector('.seconds');
  }

  connectedCallback() {
    const date = this.getAttribute('data-date');
    const hours = parseInt(this.getAttribute('data-hours')) || 0;
    const minutes = parseInt(this.getAttribute('data-minutes')) || 0;

    if (!date || !this.isValidDate(date)) {
      return;
    }

    const [month, day, year] = date.split('-').map((num) => parseInt(num));
    const targetTime = new Date(
      Date.UTC(year, month - 1, day, hours, minutes, 0),
    );

    this.startCountdown(targetTime);
  }

  isValidDate(date) {
    return /^\d{2}-\d{2}-\d{4}$/.test(date);
  }

  startCountdown(targetTime) {
    this.updateDisplay(targetTime);
    this.countdownInterval = setInterval(() => {
      this.updateDisplay(targetTime);
    }, 1000);
  }

  updateDisplay(targetTime) {
    const now = new Date();
    const timeDiff = targetTime - now;

    if (timeDiff <= 0) {
      clearInterval(this.countdownInterval);
      this.innerHTML = '';
      return;
    }

    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

    this.displayDay.innerHTML = days;
    this.displayHour.innerHTML = hours;
    this.displayMinute.innerHTML = minutes;
    this.displaySecond.innerHTML = seconds;
  }
}

if (!customElements.get('leo-countdown')) {
  customElements.define('leo-countdown', LeoCountdown);
}
